<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-snackbar
      v-model="snackbar"
      xs12
      multi-line
      :timeout="timeout"
      top
      color="orange"
    >
      {{ alertmessage }}
      <v-btn
        color="white"
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>

    <sequential-entrance from-top>
      <v-row>
        <v-col>
          <base-material-card
            color="primary"
            icon="mdi-checkbook"
            inline
          >
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">
                Deposit Checks {{ sitedetails.idnum }}
              </div>
            </template>
            <v-data-table
              :headers="headers"
              :items="getinhouseshipments"
              :single-expand="singleExpand"
              :expanded.sync="expanded_deposits"
              :items-per-page="10"
              :search="search"
              sort-by="timestamp"
              sort-desc
              expand-icon="mdi-information"
              item-key="timestamp"
              show-expand
              class="elevation-1"
              @item-expanded="loadDepositDetails"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                  color="white"
                >
                  <v-toolbar-title>Entries</v-toolbar-title>

                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  />
                  <v-spacer />
                  <v-dialog
                    v-model="dialog"
                    max-width="900px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="warning"
                        dark
                        class="mb-2"
                        to="/checkmanagement"
                      >
                        Return
                      </v-btn><v-btn
                        color="primary"
                        dark
                        class="mb-2 mr-4"
                        v-on="on"
                      >
                        New Check Deposit
                      </v-btn>
                    </template>
                    <v-card>
                      <v-row>
                        <v-col
                          class="ma-0"
                          cols="12"
                        >
                          <validation-observer v-slot="{ valid }">
                            <base-material-wizard-check
                              v-model="tab"
                              :available-steps="availableSteps"
                              :items="tabs"
                              class="mx-auto"
                              @click:next="next(valid)"
                              @click:prev="tab--"
                            >
                              <v-tab-item class="pb-0">
                                <form>
                                  <div class="text-center display-1 font-weight-light mb-1">
                                    Please drag an image of your check or click inside the box to browse for one.
                                  </div>

                                  <v-row
                                    class="mx-auto"
                                    justify="space-around"
                                    style="max-width: 1100px;"
                                  >
                                    <v-col
                                      cols="12"
                                    >
                                      <validation-provider
                                        v-slot="{ errors }"
                                        rules="required"
                                        name="image"
                                      >
                                        <picture-input
                                          ref="pictureInput"
                                          :error-messages="errors"
                                          width="800"
                                          height="400"
                                          margin="2"
                                          accept="image/jpeg,image/png"
                                          size="10"
                                          button-class="btn"
                                          :custom-strings="{
                                            upload: '<h1>Bummer!</h1>',
                                            change: 'Change Image',
                                            drag: 'Drag a check image or click to browse'
                                          }"
                                          @change="onChange"
                                        />
                                      </validation-provider>
                                      <v-row>
                                        <v-progress-linear
                                          :active="loading"
                                          :indeterminate="loading"
                                          absolute
                                          color="primary"
                                        />
                                      </v-row>
                                      <v-row v-if="checkProcessData">
                                        <v-col>
                                          <v-card-text class="justify-center display-2 font-weight-light pt-2">
                                            Check Number {{ checkProcessData.checkNumber }}
                                            Routing Number {{ checkProcessData.routingNumber }}
                                            Account Number {{ checkProcessData.accountNumber }}
                                          </v-card-text>
                                          <v-card-text class="justify-center display-2 font-weight-light pt-2">
                                            Amount: {{ checkamount }}
                                          </v-card-text>
                                        </v-col>
                                      </v-row>
                                    </v-col>
                                  </v-row>
                                </form>
                              </v-tab-item>

                              <v-tab-item class="pb-0">
                                <form>
                                  <v-responsive
                                    class="mx-auto"
                                    max-width="1100"
                                  >
                                    <div class="text-center display-1 grey--text font-weight-light mb-1">
                                      Please drag an image of the BACK of the check or click inside the box to browse for one.
                                    </div>
                                    <validation-provider
                                      v-slot="{ errors }"
                                      rules="required"
                                      name="imageBack"
                                    >
                                      <picture-input
                                        ref="pictureInput"
                                        :error-messages="errors"
                                        width="800"
                                        height="400"
                                        margin="2"
                                        accept="image/jpeg,image/png"
                                        size="10"
                                        button-class="btn"
                                        :custom-strings="{
                                          upload: '<h1>Bummer!</h1>',
                                          change: 'Change Image',
                                          drag: 'Drag a check image or click to browse'
                                        }"
                                        @change="onChangeBack"
                                      />
                                    </validation-provider>
                                  </v-responsive>
                                </form>
                              </v-tab-item>
                              <v-tab-item class="pb-1">
                                <div class="text-center display-1 grey--text font-weight-light mb-1">
                                  Verify Check Data
                                </div>

                                <form>
                                  <v-row
                                    v-if="image"
                                    class="justify-center"
                                  >
                                    <v-col
                                      class="d-flex justify-center"
                                      cols="12"
                                    >
                                      <v-img
                                        :src="`data:image/jpeg;base64,${checkProcessData.check21Base64Jpg}`"
                                        contain
                                        height="400"
                                        width="800"
                                      />
                                    </v-col>
                                  </v-row>
                                  <v-row
                                    class="ma-2 pa-2"
                                  >
                                    <v-col
                                      cols="4"
                                    >
                                      <v-text-field
                                        v-model="checkProcessData.checkNumber"
                                        outlined
                                        color="primary"
                                        label="Check Number"
                                        validate-on-blur
                                      />
                                    </v-col>
                                    <v-col
                                      cols="4"
                                    >
                                      <v-text-field
                                        v-model="checkProcessData.routingNumber"
                                        outlined
                                        color="primary"
                                        label="Routing Number"
                                        validate-on-blur
                                      />
                                    </v-col>
                                    <v-col
                                      cols="4"
                                    >
                                      <v-text-field
                                        v-model="checkProcessData.accountNumber"
                                        outlined
                                        color="primary"
                                        label="Account Number"
                                        validate-on-blur
                                      />
                                    </v-col>
                                  </v-row>
                                  <v-row
                                    class="ma-2 pa-2"
                                  >
                                    <v-col
                                      cols="4"
                                    >
                                      <validation-provider
                                        v-slot="{ errors }"
                                        rules="required"
                                        name="amount"
                                      >
                                        <v-text-field
                                          v-model="checkdata.amount"
                                          :error-messages="errors"
                                          outlined
                                          color="primary"
                                          label="Check Amount"
                                          validate-on-blur
                                        />
                                      </validation-provider>
                                    </v-col>
                                  </v-row>
                                </form>
                              </v-tab-item>
                            </base-material-wizard-check>
                          </validation-observer>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>

              <template v-slot:[`item.carrier`]="{ item }">
                USPS
              </template>
              <template v-slot:[`item.label`]="{ item }">
                <a
                  :href="getlabelpdfurl(item)"
                  target="_blank"
                >
                  <v-icon color="red">mdi-pdf-box</v-icon><v-icon>mdi-download</v-icon>
                </a>
              </template>
              <template v-slot:[`item.timestamp`]="{ item }">
                {{ format_time(item.timestamp) }}
              </template>

              <template v-slot:[`item.amount`]="{ item }">
                {{ format_amt(item.postaldeposit.DepositAmount) }}
              </template>
              <template v-slot:[`item.bagid`]="{ item }">
                {{ item.postaldeposit.BagNumber }}
              </template>
              <template v-slot:[`item.trackingnumber`]="{ item }">
                {{ item.tracking_number }}
              </template>
              <template v-slot:[`item.vaultstatus`]="{ item }">
                Delivered
              </template>
              <template v-slot:no-data>
                Sorry, No info {{ sitedetails.idnum }}
              </template>

              <template v-slot:expanded-item="{ headers, item }">
                <td
                  :colspan="headers.length"
                  class="white"
                >
                  <v-card
                    elevation="2"
                    outlined
                  >
                    <v-card-text class="title">
                      nothing
                    </v-card-text>
                  </v-card>
                </td>
              </template>
            </v-data-table>
          </base-material-card>

          <div class="py-3" />
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import { utcToZonedTime, format, zonedTimeToUtc } from 'date-fns-tz'
  import { jsPDF } from 'jspdf'
  import PictureInput from 'vue-picture-input'
  var numeral = require('numeral')

  export default {

    name: 'Depositusersbysite',
    components: {
      PictureInput,
    },

    props: ['id'],
    data: () => ({
      account: [],
      accounts: [
        {
          icon: 'mdi-pencil',
          type: 'design',
        },
        {
          icon: 'mdi-code-tags',
          type: 'code',
        },
        {
          icon: 'mdi-laptop',
          type: 'develop',
        },
      ],
      address: '',
      city: '',
      email: '',
      first: '',
      image: null,
      imageBack: null,
      last: '',
      state: '',
      street: '',
      tab: 0,
      tabs: ['Check Front', 'Check Back', 'Summary'],
      imgs: '',
      visible: false,
      index: 0,
      id_images: [
        { img: '/img/id_front.jpg', type: 'front', set: false },
        { img: '/img/id_back.jpg', type: 'back', set: false },
      ],
      lightboxImages: [],
      img_data_front: null,
      img_data_back: null,
      id_front: '/img/id_front.jpg',
      id_back: '/img/id_back.jpg',
      camera: null,
      deviceId: null,
      devices: [],
      camimg: '',
      dialog: false,
      selected: [],
      sitedetails: '',
      snackbar: false,
      unit_id: '',
      timeout: 7000,
      singleSelect: false,
      search: '',
      alertmessage: '',
      headers: [
        { text: 'Created', align: 'left', value: 'timestamp', sortable: true },
        { text: 'Tracking ID', align: 'left', value: 'trackingnumber', sortable: true },
        { text: 'Payee', align: 'center', value: 'manifest', sortable: true },
        { text: 'Amount', align: 'center', value: 'amt', sortable: true },
        { text: 'Process Date', align: 'left', value: 'timestamp', sortable: true },
        { text: 'Status', align: 'center', value: 'vaultstatus', sortable: true },
      ],
      checkheaders: [
        { text: 'Name', align: 'left', value: 'Name', sortable: true },
        { text: 'Confidence', align: 'left', value: 'Confidence', sortable: true },
        { text: 'Value', align: 'left', value: 'Value', sortable: true, },
      ],
      bagheaders: [
        { text: 'Bag ID', align: 'center', value: 'securebagdeposit.BagNumber', sortable: true },
        { text: 'Deposit Amount', align: 'center', value: 'securebagdeposit.DepositAmount', sortable: true },
      ],
      alerts: [],
      depositusers: [],
      expanded: [],
      expanded_deposits: [],
      singleExpand: true,
      editedIndex: -1,
      editedItem: {
        safeid: '',
        bags: [],
        idnum: '',
        timestamp: '',
        allowedusers: '',
        duration: '',
        washifyid: '',
        source: '',
        status: '',
        userid: '',
        amount: '',
      },
      defaultItem: {
        safeid: '',
        idnum: '',
        bags: [],
        timestamp: '',
        duration: '',
        allowedusers: '',
        washifyid: '',
        status: '',
        userid: '',
        amount: '',
        source: '',
      },
      gallery: [],
      checkdata: {
        RecognitionResult: '',
        amount: '',
        accountNumber: '',
        check21Base64Jpg: '',
        checkNumber: '',
        croppedMicr: '',
        croppedTiff: '',
        routingNumber: '',
        tempId: ''
      },
      default_checkdata: {
        RecognitionResult: '',
        amount: '',
        accountNumber: '',
        check21Base64Jpg: '',
        checkNumber: '',
        croppedMicr: '',
        croppedTiff: '',
        routingNumber: '',
        tempId: ''
      }
    }),

    computed: {
      checkamount () {
        return numeral(this.checkdata.amount).format('$0,000.00')
      },
      stringAccount () {
        return this.account.join(',')
      },
      scope () {
        if (this.tab === 0) return 'about'
        else if (this.tab === 2) return 'address'
        return 'account'
      },
      availableSteps () {
        const steps = [0]

        if (
          this.image && this.$store.getters.getCheckFrontData
        ) steps.push(1)

        if (this.imageBack && steps.includes(1)) steps.push(2)

        if (
          this.address &&
          this.street &&
          this.city &&
          this.state &&
          steps.includes(2)
        ) steps.push(3)

        return steps
      },
      loading () {
        // return true
        return this.$store.getters.getloading
      },
      checkProcessData () {
        let data = this.$store.getters.getCheckFrontData
        this.checkdata.accountNumber = data.accountNumber
        this.checkdata.checkNumber = data.checkNumber
        this.checkdata.croppedMicr = data.croppedMicr
        this.checkdata.routingNumber = data.routingNumber
        this.checkdata.amount = 0
        if (data.RecognitionResult) {
          let fieldarray = []
          let fields = Object.values(this.$store.getters.getCheckFrontData.RecognitionResult.Response.Fields.Field)
          fields.forEach(entry => {
            console.log('entry ', entry)
            if (entry.Name === 'Amount') {
              console.log('amount found ', entry)
              this.checkdata.amount = entry.Value
              console.log(' amount set ', this.checkdata.amount)
            }
          })
        }
        return this.$store.getters.getCheckFrontData
      },
      showFields () {
        let fields
        let fieldarray = []
        if (this.$store.getters.getCheckFrontData.RecognitionResult) {
          fields = Object.values(this.$store.getters.getCheckFrontData.RecognitionResult.Response.Fields.Field)
          fields.forEach(entry => {
            fieldarray.push({ Name: entry.Name, Value: entry.Value, Confidence: entry.Confidence, Accepted: entry.Accepted })
          })
        }

        return fieldarray
      },
      listDepositImages () {
        this.id_images = [
          { img: '/img/id_front.jpg', type: 'front', set: false },
          { img: '/img/id_back.jpg', type: 'back', set: false },
        ]
        let imageUrls = []
        this.gallery = []
        imageUrls = this.$store.getters.getDepositImages
        imageUrls.forEach(entry => {
          this.gallery.push({ src: entry })
        })
        return imageUrls
      },
      togglecam () {
        if (this.activecam) {
          this.activecam = false
          return
        }
        this.activecam = true
      },
      getfrontimge () {
        return this.id_images[0].img
      },
      getbackimage () {
        return this.id_images[1].img
      },
      device: function () {
        return this.devices.find(n => n.deviceId === this.deviceId)
      },
      menuforstatus () {
        if (this.$store.getters.user.status === 'storemanager') {
          return []
        } else if (this.$store.getters.user.status === 'groupmanager') {
          return []
        } else if (this.$store.getters.user.status === 'corporate') {
          return [
            {
              text: 'Create Bags',
              value: 'deposits',
              color: 'pink',
              icon: 'mdi-shopping-outline',
              nav: '/Inhousedeposit/'
            },
            {
              text: 'Tracking',
              value: 'cit',
              color: 'green',
              icon: 'mdi-transfer-right',
              nav: '/Inhousetracking/'
            },
          ]
        } else if (this.$store.getters.user.status === 'admin') {
          return [
            {
              text: 'Create Bags',
              value: 'deposits',
              color: 'pink',
              icon: 'mdi-shopping-outline',
              nav: '/Inhousedeposit/'
            },
            {
              text: 'Tracking',
              value: 'cit',
              color: 'green',
              icon: 'mdi-transfer-right',
              nav: '/Inhousetracking/'
            },
          ]
        }
      },
      formIsValid () {
        return this.editedItem.email !== '' &&
          this.editedItem.accesscode !== '' &&
          this.editedItem.username !== ''
      },
      instructionTitle () {
        if (this.image) {
          return 'Check Image Loaded'
        }
        return 'Click to load image'
      },
      formTitle () {
        return this.editedIndex === -1 ? 'New Check Entry' : 'Edit Check Entry'
      },
      getsecurebagdeposits () {
        let securebags = this.$store.getters.getLoadedSecureBagDeposits
        return securebags.filter(deposit => deposit.shipped !== true)
      },
      totalShipment () {
        let total = 0
        this.selected.forEach(item => {
          total += parseFloat(item.securebagdeposit.DepositAmount)
        })
        return numeral(total).format('$0.00')
      },
      getinhouseshipments () {
        let recs = this.$store.getters.getLoadedInHouseShipments
        for (let record of recs) {
          let sum = 0
          record.contents.forEach(item => {
            sum += parseFloat(item.securebagdeposit.DepositAmount)
          })
          Object.assign(record, { count: record.contents.length })
          Object.assign(record, { amt: numeral(sum).format('$0.00') })
        }
        // get count of the contents
        // get total amount of the bags
        return recs
      },

      getshipments () {

      }
    },

    watch: {
      camera: function (id) {
        this.deviceId = id
      },
      devices: function () {
        // Once we have a list select the first one
        const [first, ...tail] = this.devices
        if (first) {
          this.camera = first.deviceId
          this.deviceId = first.deviceId
        }
      },
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.id = this.$route.params.id
      this.getsitemap(this.id)
      this.$log.debug('LOADING THIS ID ', this.id)
    },
    beforeDestroy () {
      // this.$store.dispatch('stoprealtimepostalshipments', this.id)
    },
    methods: {
      next (valid) {
        console.log('valid is ', valid, ' tab ', this.tab)

        if (!valid && !this.image) return
        if (this.tab === 0) {
          // we do this because we're done with this image
          this.$refs.pictureInput.removeImage()
        }
        if (this.tab === 1) {
          console.log('2nd tab has been passed to processing')
        }
        console.log('valid is ', valid, ' image is not ')
        if (this.tab === this.tabs.length - 1) {
          alert('Form finished')
        } else {
          this.tab++
          window.scrollTo(0, 0)
        }
      },
      onChangeBack (image) {
        console.log('New picture selected!')
        if (image) {
          console.log('Back Picture loaded.')
          this.imageBack = image
        } else {
          console.log('FileReader API not supported: use the <form>, Luke!')
        }
      },
      onChange (image) {
        console.log('New picture selected!')
        this.$store.dispatch('clearCheck')
        if (image) {
          console.log('Picture loaded.')
          this.image = image
          this.processCheck() // hit it!
        } else {
          console.log('FileReader API not supported: use the <form>, Luke!')
        }
      },
      handleImages (files) {
        console.log(files)
        let readers = []
        let imgs = []
        if (!files.length) return
        for (let i = 0; i < files.length; i++) {
          readers.push(this.readAsDataURL(files[i]))
        }
        Promise.all(readers).then((values) => {
          imgs = values
          console.log('image values ', imgs)
        })
      },
      readAsDataURL (file) {
        return new Promise(function (resolve, reject) {
          let fr = new FileReader()
          fr.onload = function () {
            resolve(fr.result)
          }
          fr.onerror = function () {
            reject(fr)
          }
          fr.readAsDataURL(file)
        })
      },
      showSingle (index) {
        this.imgs = this.$store.getters.getDepositImages[index]
        // or
        this.show()
      },
      showMultiple () {
        this.imgs = ['http://via.placeholder.com/350x150', 'http://via.placeholder.com/350x150']
        // or
        this.imgs = [
          { title: 'test img', src: 'http://via.placeholder.com/350x150' },
          'http://via.placeholder.com/350x150'
        ]
        // allow mixing

        this.index = 1 // index of imgList
        this.show()
      },
      show () {
        this.visible = true
      },
      handleHide () {
        this.visible = false
      },
      loadDepositDetails ({ item }) {
        console.log('this was expanded ', item)
        let depositRec = {
          sitekey: this.sitedetails.sitekey,
          trackingnumber: item.tracking_number
        }
        this.$store.dispatch('listCloudDepositImagesAsync', depositRec)
      },
      onCapture (item) {
        console.log('item passed ', item)
        this.img = this.$refs.webcam.capture()
        let imageRec = {
          img: this.img,
          sitekey: this.sitedetails.sitekey,
          trackingnumber: item.tracking_number
        }
        // this.$store.dispatch('uploadMetadata', imageRec)
        if (this.id_images[0].set === false) {
          console.log('set image front')
          this.id_images[0].set = true
          this.id_images[0].img = this.img
          this.img_data_front = this.img
        } else {
          console.log('set image back')
          this.id_images[1].set = true
          this.id_images[1].img = this.img
          this.id_images[0].set = false
          this.img_data_back = this.img
        // this.id_images[1] =
        }

      // console.log('image is ', this.img)
      },
      onStarted (stream) {
        console.log('On Started Event', stream)
      },
      onStopped (stream) {
        console.log('On Stopped Event', stream)
      },
      onStop () {
        this.$refs.webcam.stop()
      },
      onStart () {
        this.$refs.webcam.start()
      },
      onError (error) {
        console.log('On Error Event', error)
      },
      onCameras (cameras) {
        this.devices = cameras
        console.log('On Cameras Event', cameras)
      },
      onCameraChange (deviceId) {
        this.deviceId = deviceId
        this.camera = deviceId
        console.log('On Camera Change Event', deviceId)
      },
      onDismissed () {
        this.clientwarned = true
        this.$store.dispatch('clearError')
      },
      onDecode (result) {
        this.result = result
      },
      initialize () {
        this.alerts = this.$store.getters.alerts
        this.depositusers = this.$store.getters.loadedPendingDeposits
      },
      gettopurl (nav) {
        let url = nav + this.id
        return url
      },
      format_time (ts) {
        this.$log.debug('TS ', ts)
        return moment(ts).format('YYYY-MM-DD, HH:mm:ss')
      },
      format_amt (amt) {
        this.$log.debug('amt ', amt)
        return numeral(amt).format('$0,0.00')
      },
      getlabelpdfurl (data) {
        let url = ''
        if (data.label_download) {
          url = data.label_download.pdf
        }
        return url
      },
      getsitemap (machineid) {
        this.$log.debug('sitemap')
        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          // this.$log.debug(`${key}: ${value}`)
          if (value.siteunitsprofile) {
            if (value.siteunitsprofile[0].crypto_idnum === machineid) {
              this.$log.debug(value)
              this.sitedetails = this.$store.getters.loadedSites.find(location => value.idnum === location.idnum)
            }
          }
        }
        this.$store.dispatch('loadsecuritybagdeposits', machineid)
        this.$store.dispatch('loadinhouseshipments', machineid)
        // this.$store.dispatch('initrealtimepostalshipments', machineid)
      },
      editItem (item) {
        this.editedIndex = this.depositusers.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.depositusers.indexOf(item)
        this.$log.debug('site info is ', item)
        if (confirm('Are you sure you want to delete this item?') && this.depositusers.splice(index, 1)) {
          this.$log.debug('site info is ', item.key)
          let rec = {
            key: item.key,
            siteid: this.id
          }
          this.$store.dispatch('removePendingDeposit', rec)
        }
      },
      close () {
        console.log('closing the pop up', this.$refs)
        this.checkdata = this.default_checkdata
        this.tab = 0
        // from component
        this.$refs.pictureInput.removeImage()
        this.dialog = false
        this.selected = []
        this.image = null
        this.imageBack = null
        // clear the store details
        this.$store.dispatch('clearCheck')
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      processCheck () {
        let rec = {
          image: this.image,
          sitekey: this.sitedetails.sitekey,
          amount: '0.00'
        }
        this.$store.dispatch('check21_process_check', rec)
      },
      resetCheck () {
        this.image = ''
        this.$store.dispatch('clearCheck')
      },
      savecheck () {
        this.editedItem = this.defaultItem // reset values
        this.alertmessage = 'Your deposit has been recorded'
        this.snackbar = true
        this.dialog = false
      },
      saveinhouseshipment () {
        let postaldeposit = { Name: 'Unsent', Amount: '0' } // we dont know whats in the bag yet
        let pickupday = moment().add(1, 'day').format('YYYY-MM-DD')
        let timezone = 'America/New_York'
        let tstart = pickupday + ' ' + '12:00'
        let tend = pickupday + ' ' + '16:00'
        let start = zonedTimeToUtc(tstart, timezone)
        let end = zonedTimeToUtc(tend, timezone)
        let rec = {
          siteid: this.sitedetails.idnum,
          safeid: this.id,
          contents: this.selected,
          used: false,
          postaldeposit: '',
          timestamp: Date.now(),
          pickupstart: start.toISOString(),
          pickupend: end.toISOString(),
          sitedetails: this.sitedetails
        }
        this.editedItem = this.defaultItem // reset values
        this.alertmessage = 'Your deposit has been recorded'
        this.snackbar = true
        this.$store.dispatch('createInHouseBankPackage', rec)
        this.dialog = false
        // this.$store.dispatch('loadpostalshipments', this.id)

        //  this.$store.dispatch('loadpostaldeposits', this.id)
        // this.$store.dispatch('loadpostaldeposits', this.$route.params.id)
      },
    },
  }
</script>
